/**
 * Formats SSH restart status codes into human-readable strings.
 * Returns the original status if it doesn't match known values.
 */
export function formatSshStatus(
  status: 'QUEUED' | 'STARTED' | 'COMPLETED' | 'EXPIRED' | 'CANCELLED' | 'FAILED' | (string & Record<never, never>), // Allow other strings but provide autocomplete
): string {
  switch (status) {
    case 'QUEUED':
      return 'Queued'
    case 'STARTED':
      return 'Started'
    case 'COMPLETED':
      return 'Completed'
    case 'EXPIRED':
      return 'Expired'
    case 'CANCELLED':
      return 'Cancelled'
    case 'FAILED':
      return 'Failed'
    default:
      // Log unexpected status for debugging
      if (status) {
        console.warn(`Unexpected SSH status received: ${status}`)
      }
      return status
  }
}

/**
 * Formats SMS delivery status codes into human-readable strings.
 * Returns the original status if it doesn't match known values.
 */
export function formatSmsStatus(
  status:
    | 'DELIVERED_TO_SERVICE_PROVIDER'
    | 'DELIVERED_TO_MOBILE_OPERATOR'
    | 'DELIVERED_TO_RECIPIENT'
    | 'DELIVERY_FAILED'
    | 'MESSAGE_EXPIRED'
    | (string & Record<never, never>),
): string {
  switch (status) {
    case 'DELIVERED_TO_SERVICE_PROVIDER':
      return 'Delivered to service provider'
    case 'DELIVERED_TO_MOBILE_OPERATOR':
      return 'Delivered to mobile operator'
    case 'DELIVERED_TO_RECIPIENT':
      return 'Delivered to recipient'
    case 'DELIVERY_FAILED':
      return 'Delivery failed'
    case 'MESSAGE_EXPIRED':
      return 'Message expired'
    default:
      // Log unexpected status for debugging
      if (status) {
        console.warn(`Unexpected SMS status received: ${status}`)
      }
      return status
  }
}
